<template>
    <div>
        <slot
            :addProduct="addProduct"
            :updateAmount="updateAmount">
            <button
                @click="addProduct()"
                class="mao-button yellow full-w">
                <i class="fa fa-shopping-cart"></i>
                <span class="{'disableText': orderBtnText}">{{ __('Bestellen') }}</span>
            </button>
        </slot>
    </div>
</template>

<script setup lang="ts">
    import type {Product} from './types/Product';
    import {computed, onBeforeMount, PropType, ref} from 'vue';
    import {shoppingCartStore, siteSettings as siteSettingsStore, eventsNotif} from './Store.ts';
    import Modal from './Modal.vue';
    import AddedProductModal from './AddedProductModal.vue';

    let showModal = ref(false);
    const store = shoppingCartStore();
    const siteSettings = siteSettingsStore();
    const eventsNotifs = eventsNotif();
    const props = defineProps({
        item: {
            type: Object as PropType<Product>,
            required: true,
        },
        modalExist: {
            type: Boolean,
            default: true,
        },
        orderBtnText: {type: Boolean, default: false},
    });

    const product = ref<Product | null>(null);
    const amount = ref(props.item.orderQuantity);
    const nextAction = window.route.shoppingcart.cart;
    function updateAmount(x) {
        amount.value = x.value;
    }
    onBeforeMount(() => {
        product.value = store.filterProductFields(props.item);
    });
    function addProduct() {
        store.addItem(product.value, amount.value);
        showModal.value = true;
        eventsNotifs.shoppingCartSummaryAlert = true;

        window.modal.product = product.value;
        window.modal.showModal = true;
    }

    const currentPrice = computed(() => product.value.netPrice * siteSettings.btw);
    const oldPrice = computed(() => product.value.grossPrice * siteSettings.btw);
</script>

<style scoped>
    @media (max-width: 767px) {
        .disableText {
            display: none;
        }
    }
</style>
